import React from 'react';
import { useObservable } from 'react-use-observable';

import { Row, Col } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';
import shoppingService from 'v2/services/shopping/product';

import Approve from './Approve';
import Details from './Details';
import RefundList from './List';
import MassApprove from './MassApprove';
import RefundSelect from './RefundSelected';
import ReproveMotive from './ReproveMotive';

const Refund = () => {
  useObservable(() => shoppingService.loadDeliveries(), []);

  return (
    <div id={'request-management-refund'}>
      <Row gutter={[16, 16]}>
        <PermissionHide action='myeduzz:request-management:aprovar'>
          <RefundSelect />
        </PermissionHide>

        <Col span={24}>
          <RefundList />
          <PermissionHide action='myeduzz:request-management:detalhes'>
            <Details />
          </PermissionHide>
          <PermissionHide action='myeduzz:request-management:aprovar'>
            <ReproveMotive />
            <Approve />
            <MassApprove />
          </PermissionHide>
        </Col>
      </Row>
    </div>
  );
};

export default Refund;
